import domWrap from "../utils/domWrap";
import h from "../utils/htm";

export default async container => { // 'comp-filters'
	
	let filter,
		category = getCategoryType(decodeURIComponent(location.hash.replace('#', '').split('category=').pop()));
	
	container.innerHTML = h('div class="categories"',
		container.getAttribute('categories').split(',').reduce((html, item) => {
			const categoryItem = getCategoryType(item);
			return html + h('button cat="' + item + '" class="toggle' + (category === categoryItem ? ' on' : '')+'"',item);
		},'')
	).toString() +
	h('div class="applications"',
		h('select',
			container.getAttribute('applications').split(',').sort().reduce((html,item) => {
				return html + h('option value="'+item+'"',item);
			},h('option value="" disabled selected','Filter by Application'))
		)
	).toString();
		
	domWrap(container)
	.on('click','button',function(){
		const 	active = this.classList.contains('on');
		category = active ? undefined : getCategoryType(this.innerHTML);
		[...container.querySelectorAll('button')].forEach(button => button.classList[button === this && !active ? 'add' : 'remove']('on'));
		filter = undefined;
		[...document.querySelectorAll('comp-filters select')].forEach(select => {
			[...select.querySelectorAll('option')].forEach(option => option.selected = option.defaultSelected);
		});
		location.hash = category ? 'category=' + category : '';
		reduce({category,filter});
	})
	.on('change','select',function(){
		filter = this.value;
		reduce({category,filter});
	});
	reduce({category,filter});

	window.addEventListener('hashchange',function(){
		category = getCategoryType(decodeURIComponent(location.hash.replace('#', '').split('category=').pop()));
		[...container.querySelectorAll('.categories > *')].forEach(cat => cat.classList[cat.getAttribute('cat') === category ? 'add' : 'remove']('on'));
		reduce({category,filter});
		[...document.querySelectorAll('.slide-open')].forEach(slide => domWrap(slide.querySelector('.close')).trigger('click'));
	});
};

const getCategoryType = (() => {

	const categories = {
		'unknown': '',
		'all': '',
		'electric': 'Electric',
		'mediumduty': 'Medium Duty',
		'naturalgas': 'Natural Gas',
		'onhighway': 'On-Highway',
		'severeduty': 'Severe Duty'
	};

	const regex = /[^a-zA-Z0-9]/g;

	return (category) => {
		
		if (!category)
			category = '';

		category = category.toLowerCase().replace(regex, '');
		
		if (categories[category] !== undefined)
			return categories[category];
		
		return categories.unknown;
	}
})();

function resultsMessage({count,total,category,filter}){
	if(count === total){
		return '';
	}
	return count + ' ' + (category || '') + ' ' + (filter || '') + (!filter || filter.toLowerCase().indexOf('truck') === -1 ? ' Truck' : '') + (count === 1 ? '' : 's') + ' Found - ' + h('a href="#"','Show All Trucks');
}

function reduce({category,filter}){
	let items = [...document.querySelectorAll('comp-card-list a')],
		itemsForCat = items.filter(item => category === undefined || item.getAttribute('categories').indexOf(category) !== -1),
		select = document.querySelector('comp-filters'),
		filters = [...select.querySelectorAll('option')],
		availFilters = itemsForCat.filter((value, index, self) => self.indexOf(value) === index).reduce((arr,item) => {
			return arr.concat(item.getAttribute('applications').split(','));
		},[]);


	filters.forEach(filter => domWrap(filter).classList[filter.value !== '' && availFilters.indexOf(filter.value) === -1 ? 'add' : 'remove']('hidden'));
	
	items.forEach(item => item.classList[(category !== undefined && item.getAttribute('categories').indexOf(category) === -1) || (filter !== undefined && item.getAttribute('applications').indexOf(filter) === -1) ? 'add' : 'remove']('hidden'));


	let filterResults = document.querySelector('.filter-results');
	filterResults.innerHTML = resultsMessage({count:document.querySelectorAll('comp-card-list a:not(.hidden)').length,total:document.querySelectorAll('comp-card-list a').length, category, filter});
	[...filterResults.querySelectorAll('a')].forEach(a => a.addEventListener('click',function(e){
		e.preventDefault();
		[...select.querySelectorAll('button')].forEach(button => button.classList.remove('on'));
		filter = undefined;
		category = undefined;
		[...document.querySelectorAll('comp-filters select')].forEach(select => {
			[...select.querySelectorAll('option')].forEach(option => option.selected = option.defaultSelected);
		});
		reduce({category,filter});
	}));
}